module.exports = __webpack_public_path__ + "static/media/PartnerYandexLogo.c1563306.png";